import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TutorialService } from 'src/app/core/services/tutorial.services';

@Component({
    selector: 'app-tutorial-popup',
    templateUrl: './tutorial-popup.component.html',
    styleUrls: ['./tutorial-popup.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class TutorialPopupComponent {
  isVisible = false;
  top = "";
  left = "";
  heading = "";
  content = "";
  options: any = {};
  arrowClass = "top_left";

  constructor(private tutorialService: TutorialService) {
    this.tutorialService.openTutorialPopupCalled$.subscribe(data => {
      const { top, left, heading, content, arrowClass, options = {} } = data;

      this.top = `${top}px`;
      this.left = `${left}px`;
      this.heading = heading;
      this.content = content;
      this.arrowClass = arrowClass;
      this.options = options;

      this.isVisible = true;
    })
  }

  crossClicked() {
    this.isVisible = false;
  }
}
